import { type Profile } from "@prismicio/editor-fields"
import { useStableCallback } from "@prismicio/editor-support/React"
import { Tooltip } from "@prismicio/editor-ui"
import { Suspense, useCallback, useEffect, useState } from "react"

import { useProfile } from "../services/user"

export function SuperUserReminder() {
  const [show, setShow] = useState(false)

  function onProfileFetched(profile: Profile) {
    if (profile.superPower) setShow(true)
  }

  return (
    <Suspense>
      <BlockingProfileFetcher onProfileFetched={onProfileFetched} />
      {show && <SuperUserRedDot />}
    </Suspense>
  )
}

function SuperUserRedDot() {
  const setRingRef = useCallback((element: HTMLElement | null) => {
    if (!element) return

    element.animate(
      [
        { transform: "scale(0.1, 0.1)", opacity: 0 },
        { opacity: 1 },
        { transform: "scale(1.2, 1.2)", opacity: 0 },
      ],
      { duration: 1_000, iterations: Infinity },
    )
  }, [])

  return (
    <Tooltip title="You are a super user" content="Be careful! 💣">
      <div
        style={{
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          position: "fixed",
          zIndex: 99_999,
          top: 28,
          left: 20,
        }}
      >
        <div
          style={{
            width: 16,
            height: 16,
            backgroundColor: "#CA3214",
            borderRadius: "50%",
          }}
        />
        <div
          ref={setRingRef}
          style={{
            position: "absolute",
            width: 26,
            height: 26,
            borderRadius: 26,
            border: "3px solid #CA3214",
            opacity: 1,
          }}
        />
      </div>
    </Tooltip>
  )
}

interface BlockingProfileFetcherProps {
  onProfileFetched: (profile: Profile) => void
}

function BlockingProfileFetcher(props: BlockingProfileFetcherProps) {
  const onProfileFetched = useStableCallback(props.onProfileFetched)

  const profile = useProfile()

  useEffect(() => {
    onProfileFetched(profile)
  }, [onProfileFetched, profile])

  return null
}
